<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">{{ $t("settingsPage.mobileVersionsTitle") }}</div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <h2 class="mb-4" style="color: #e21024;">{{ $t("settingsPage.passengerApp") }}</h2>

                <h3 class="mb-4">{{ $t("settingsPage.applePassenger") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.majorVersion") }}</label>
                <v-text-field outline v-model="model.MAJOR_VERSION_APPLE_PASSENGER" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.majorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minorVersion") }}</label>
                <v-text-field outline v-model="model.MINOR_VERSION_APPLE_PASSENGER" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.minorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <h3 class="mb-4 mt-4">{{ $t("settingsPage.androidPassenger") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.majorVersion") }}</label>
                <v-text-field outline v-model="model.MAJOR_VERSION_ANDROID_PASSENGER" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.majorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minorVersion") }}</label>
                <v-text-field outline v-model="model.MINOR_VERSION_ANDROID_PASSENGER" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.minorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <h3 class="mb-4 mt-4">{{ $t("settingsPage.updateMessagesPassenger") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.generalMessageAr") }}</label>
                <v-text-field outline v-model="model.GENERAL_MESSAGE_PASSENGER_AR"
                  :label="$t('settingsPage.generalMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.generalMessageEn") }}</label>
                <v-text-field outline v-model="model.GENERAL_MESSAGE_PASSENGER_EN"
                  :label="$t('settingsPage.generalMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.forceUpdateMessageAr") }}</label>
                <v-text-field outline v-model="model.FORCE_UPDATE_MESSAGE_PASSENGER_AR"
                  :label="$t('settingsPage.forceUpdateMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.forceUpdateMessageEn") }}</label>
                <v-text-field outline v-model="model.FORCE_UPDATE_MESSAGE_PASSENGER_EN"
                  :label="$t('settingsPage.forceUpdateMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.optionalUpdateMessageAr") }}</label>
                <v-text-field outline v-model="model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_AR"
                  :label="$t('settingsPage.optionalUpdateMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.optionalUpdateMessageEn") }}</label>
                <v-text-field outline v-model="model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_EN"
                  :label="$t('settingsPage.optionalUpdateMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <v-divider class="my-6"></v-divider>

                <h2 class="mb-4" style="color: #e21024;">{{ $t("settingsPage.captainApp") }}</h2>

                <h3 class="mb-4">{{ $t("settingsPage.appleCaptain") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.majorVersion") }}</label>
                <v-text-field outline v-model="model.MAJOR_VERSION_APPLE_CAPTAIN" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.majorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minorVersion") }}</label>
                <v-text-field outline v-model="model.MINOR_VERSION_APPLE_CAPTAIN" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.minorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <h3 class="mb-4 mt-4">{{ $t("settingsPage.androidCaptain") }}</h3>

                <label style="font-size: large">{{ $t("settingsPage.majorVersion") }}</label>
                <v-text-field outline v-model="model.MAJOR_VERSION_ANDROID_CAPTAIN" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.majorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.minorVersion") }}</label>
                <v-text-field outline v-model="model.MINOR_VERSION_ANDROID_CAPTAIN" :rules="[rules.required, rules.version]"
                  :label="$t('settingsPage.minorVersion')" type="text" style="margin-top: 15px"></v-text-field>

                <h3 class="mb-4 mt-4">{{ $t("settingsPage.updateMessagesCaptain") }}</h3>


                <label style="font-size: large">{{ $t("settingsPage.generalMessageAr") }}</label>
                <v-text-field outline v-model="model.GENERAL_MESSAGE_CAPTAIN_AR"
                  :label="$t('settingsPage.generalMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.generalMessageEn") }}</label>
                <v-text-field outline v-model="model.GENERAL_MESSAGE_CAPTAIN_EN"
                  :label="$t('settingsPage.generalMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.forceUpdateMessageAr") }}</label>
                <v-text-field outline v-model="model.FORCE_UPDATE_MESSAGE_CAPTAIN_AR"
                  :label="$t('settingsPage.forceUpdateMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.forceUpdateMessageEn") }}</label>
                <v-text-field outline v-model="model.FORCE_UPDATE_MESSAGE_CAPTAIN_EN"
                  :label="$t('settingsPage.forceUpdateMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.optionalUpdateMessageAr") }}</label>
                <v-text-field outline v-model="model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_AR"
                  :label="$t('settingsPage.optionalUpdateMessageAr')" type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.optionalUpdateMessageEn") }}</label>
                <v-text-field outline v-model="model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_EN"
                  :label="$t('settingsPage.optionalUpdateMessageEn')" type="text" style="margin-top: 15px"></v-text-field>

                <v-btn :loading="loading" block @click="save" color="secondary">{{ $t("settingsPage.save") }}
                </v-btn>
              </v-form>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("settingsPage.mobileVersionsTitle");
  },
  name: "MobileVersionsSettings",
  data: () => ({
    loading: false,
    form: false,
    model: {
      // Passenger App
      MAJOR_VERSION_APPLE_PASSENGER: '1.0.0',
      MINOR_VERSION_APPLE_PASSENGER: '1.0.0',
      MAJOR_VERSION_ANDROID_PASSENGER: '1.0.0',
      MINOR_VERSION_ANDROID_PASSENGER: '1.0.0',
      // Captain App
      MAJOR_VERSION_APPLE_CAPTAIN: '1.0.0',
      MINOR_VERSION_APPLE_CAPTAIN: '1.0.0',
      MAJOR_VERSION_ANDROID_CAPTAIN: '1.0.0',
      MINOR_VERSION_ANDROID_CAPTAIN: '1.0.0',
      // Messages (we load real values from backend settings, then apply defaults if empty)
      FORCE_UPDATE_MESSAGE_PASSENGER_AR: '',
      FORCE_UPDATE_MESSAGE_PASSENGER_EN: '',
      OPTIONAL_UPDATE_MESSAGE_PASSENGER_AR: '',
      OPTIONAL_UPDATE_MESSAGE_PASSENGER_EN: '',
      GENERAL_MESSAGE_PASSENGER_AR: '',
      GENERAL_MESSAGE_PASSENGER_EN: '',
      FORCE_UPDATE_MESSAGE_CAPTAIN_AR: '',
      FORCE_UPDATE_MESSAGE_CAPTAIN_EN: '',
      OPTIONAL_UPDATE_MESSAGE_CAPTAIN_AR: '',
      OPTIONAL_UPDATE_MESSAGE_CAPTAIN_EN: '',
      GENERAL_MESSAGE_CAPTAIN_AR: '',
      GENERAL_MESSAGE_CAPTAIN_EN: ''
    },
    originalModel: {},
    isDirty: false,
  }),
  computed: {
    // rules live in computed (not data) so validation messages re-resolve on locale switch
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("settingsPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("settingsPage.ruleRequired"),
        version: (v) => /^\d+(\.\d+)*$/.test(v) || this.$t("settingsPage.ruleVersion"),
      };
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    axios.get("setting").then((response) => {
      // QA V3 #16: copy ONLY this tab's declared keys — see GeneralSettings.
      const data = response.data.data || {};
      Object.keys(this.model).forEach((key) => {
        if (key in data) this.model[key] = data[key];
      });

      // Apply UI defaults if values are empty, so dashboard does not show blank fields
      this.applyDefaultMessagesIfEmpty();

      // QA V4 W5 (#25) / L1: snapshot AFTER applying display defaults, so the page
      // does not load "dirty" and the diff-only save does not force-write the
      // placeholder default messages over blank stored values. Blank messages are
      // intentionally left blank in storage; VersionCheckService falls back to the
      // Constants default text at read time.
      this.originalModel = JSON.parse(JSON.stringify(this.model));

    });
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    model: {
      handler(newVal, oldVal) {
        if (Object.keys(this.originalModel).length > 0) {
          this.isDirty = JSON.stringify(newVal) !== JSON.stringify(this.originalModel);
        }
      },
      deep: true,
      immediate: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      const answer = confirm(this.$t("settingsPage.unsavedChanges"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }

  },
  methods: {
    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = this.$t("settingsPage.unsavedChanges");
      }
    },

    applyDefaultMessagesIfEmpty() {
      // These are stored SETTING VALUES sent to the mobile apps (bilingual content),
      // not dashboard UI labels — do not replace them with $t() keys.
      // Passenger update messages (general message is left empty if backend did not fill it)
      if (!this.model.FORCE_UPDATE_MESSAGE_PASSENGER_AR) {
        this.model.FORCE_UPDATE_MESSAGE_PASSENGER_AR = 'يجب تحديث التطبيق إلى الإصدار الأحدث';
      }
      if (!this.model.FORCE_UPDATE_MESSAGE_PASSENGER_EN) {
        this.model.FORCE_UPDATE_MESSAGE_PASSENGER_EN = 'You must update the app to the latest version';
      }
      if (!this.model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_AR) {
        this.model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_AR = 'يتوفر تحديث جديد للتطبيق';
      }
      if (!this.model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_EN) {
        this.model.OPTIONAL_UPDATE_MESSAGE_PASSENGER_EN = 'A new update is available for the app';
      }

      // Captain update messages
      if (!this.model.FORCE_UPDATE_MESSAGE_CAPTAIN_AR) {
        this.model.FORCE_UPDATE_MESSAGE_CAPTAIN_AR = 'يجب تحديث التطبيق إلى الإصدار الأحدث';
      }
      if (!this.model.FORCE_UPDATE_MESSAGE_CAPTAIN_EN) {
        this.model.FORCE_UPDATE_MESSAGE_CAPTAIN_EN = 'You must update the app to the latest version';
      }
      if (!this.model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_AR) {
        this.model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_AR = 'يتوفر تحديث جديد للتطبيق';
      }
      if (!this.model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_EN) {
        this.model.OPTIONAL_UPDATE_MESSAGE_CAPTAIN_EN = 'A new update is available for the app';
      }
    },

    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("settingsPage.enterValidValues"),
          "red"
        );
        return;
      }


      // QA V4 W5 (#25): PUT only the keys that actually changed since load, so a
      // concurrent edit to another key by another admin is not clobbered by this
      // tab's page-load snapshot.
      const changed = {};
      Object.keys(this.model).forEach((key) => {
        if (JSON.stringify(this.model[key]) !== JSON.stringify(this.originalModel[key])) {
          changed[key] = this.model[key];
        }
      });

      if (Object.keys(changed).length === 0) {
        window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.settingsSaved"));
        this.isDirty = false;
        return;
      }

      this.loading = true;

      this.axios
        .put(`setting/update`, changed)
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.settingsSaved"))
          this.originalModel = JSON.parse(JSON.stringify(this.model));
          this.isDirty = false;
        })
        .catch(({ response }) => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.failedSaveSettings"), "red");
          console.log(response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
